import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setUserData } from "../user/UserSlices";
import { fetchPermissionCatalog, fetchUserPermissions } from "../Permissions/UserPermissions";
import { clearPermissions } from "../Permissions/UserPermissionsSlice";

const clearStoredAuthSession = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userId");
  localStorage.removeItem("userDetails");
};

export const verifyOtp = createAsyncThunk(
  "user/verifyOtp",
  async ({ mobileNumber, otpValue }, { dispatch, rejectWithValue }) => {
    try {
      clearStoredAuthSession();
      dispatch(clearPermissions());

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/verifyOTP`,
        {
          mobileNumber,
          otp: otpValue,
        }
      );
      if (response.data) {
        let { accessToken, refreshToken, userGetId, userId } = response.data;

        localStorage.setItem("mobileNumber", mobileNumber);

        const userData = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/getuser-mobilenu?mobileNo=${mobileNumber}`
        );
        if (userData.data) {
          const isUserNotFound = userData.data?.error === "User not found.";

          if (isUserNotFound) {
            dispatch(
              setUserData({
                accessToken: null,
                refreshToken: null,
                userId: null,
                loggedInUserID: null,
                userDetails: userData.data,
              })
            );
            return {
              ...response.data,
              accessToken: null,
              refreshToken: null,
              userDetails: userData.data,
            };
          }

          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("userId", userId);
          localStorage.setItem("userDetails", JSON.stringify(userData.data));

          dispatch(
            setUserData({
              accessToken,
              refreshToken,
              userId: userGetId,
              loggedInUserID: userId,
              userDetails: userData.data,
            })
          );
          const permissionsResult = await dispatch(fetchUserPermissions());
          const catalogResult = await dispatch(fetchPermissionCatalog());
          console.debug("[Permissions] fetched after OTP", {
            permissionsResult,
            catalogResult,
          });

          return {
            ...response.data,
            userDetails: userData.data,
            permissions: permissionsResult?.payload || null,
          };
        } else {
          alert("User not found");
        }
        return response.data;
      }
      return rejectWithValue("Failed to verify OTP. Please try again.");
    } catch (error) {
      console.error("Error verifying OTP:", error);
      clearStoredAuthSession();
      dispatch(clearPermissions());
      return rejectWithValue("Failed to verify OTP. Please try again.");
    }
  }
);
